<template>
  <div id="publicarNoDiario">
    <b-row>
      <div>
        <b-card-group deck>
          <b-card header-tag="header">
            <template #header>
              <header class="text-center">Publicar no Diário Oficial</header>
            </template>
            <b-card-text class="text-justify">
              Se você é representante de órgão da Administração Pública direta
              ou indireta do Governo do Estado de Alagoas, sua publicação deve
              ser realizada por meio do Sistema do Diário Oficial do Estado de
              Alagoas (Doeal).
            </b-card-text>
            <a :href="adminUrl" class="btn btn-primary" target="_blank">
              Acesse o sistema do DOEAL
            </a>
          </b-card>
          <b-card
            header="Para os demais publicadores do Diário Oficial, seguem os passos a seguir:"
            header-tag="header"
          >
            <b-card-text class="text-justify mt-3"
              >1) Preencha todos os dados solicitados, para cadastro e emissão
              da fatura;</b-card-text
            >
            <b-card-text class="text-justify"
              >2) Anexe o arquivo Microsoft Word, com o texto na seguinte
              formatação:</b-card-text
            >
            <ul class="lista-formatacao">
              <li>Fonte: Times New Roman;</li>
              <li>Tamanho da Fonte: 8;</li>
              <li>Largura do texto: 9,3cm;</li>
              <li>
                Espaçamento simples, tanto entre linhas quanto parágrafos;
              </li>
            </ul>
            <b-card-text class="text-justify"
              >3) Após o envio do texto, aguarde e-mail de retorno, com o valor
              e os dados bancários para transferência/depósito;</b-card-text
            >
            <b-card-text class="text-justify"
              >4) Só publicamos mediante comprovação de pagamento. Portanto,
              após realizar o pagamento, é necessário responder o e-mail que
              contém o orçamento, anexando o comprovante.</b-card-text
            >
            <b-card-text class="text-justify"
              >5) Após validação, sua matéria será publicada no próximo dia
              útil.</b-card-text
            >

            <b-button v-b-modal.modal-prevent-closing variant="primary">
              Solicite um orçamento
            </b-button>
          </b-card>
        </b-card-group>
      </div>
      <b-modal
        id="modal-prevent-closing"
        ref="modal"
        title="Preencha os seguintes dados:"
        size="lg"
        @hidden="resetForm"
      >
        <form class="p-3" ref="form">
          <b-row>
            <!-- Pessoa Tipo -->
            <b-col order="1" cols="12" md="6">
              <b-form-group>
                <label for="selectPessoa">Sou pessoa:</label>
                <v-select
                  id="selectPessoa"
                  v-model="$v.formulario.pessoaTipo.$model"
                  placeholder="Selecione o tipo"
                  :options="tipoPessoa"
                  :class="{
                    'select-valid': !$v.formulario.pessoaTipo.$invalid,
                    'select-error': $v.formulario.pessoaTipo.$invalid
                  }"
                  :state="inputState($v.formulario.pessoaTipo)"
                  aria-describedby="pessoaInputLiveFeedback"
                  @input="togglePersonType"
                >
                  <template #no-options="{ search, searching }">
                    <template v-if="searching">
                      Nenhum tipo foi encontrado na pesquisa:
                      <em>{{ search }}</em
                      >.
                    </template>
                    <span v-else>
                      Nenhum tipo foi encontrado nesta consulta.
                    </span>
                  </template>
                </v-select>
                <span
                  v-if="$v.formulario.pessoaTipo.$invalid"
                  class="invalid-custom-feedback"
                >
                  Este campo é obrigatório
                </span>
              </b-form-group>
            </b-col>

            <!-- Nome -->
            <b-col order="2" cols="12" md="6">
              <b-form-group>
                <label for="name-input">Nome completo</label>
                <b-form-input
                  id="name-input"
                  v-model="$v.formulario.nome.$model"
                  :state="inputState($v.formulario.nome)"
                  aria-describedby="nameInputLiveFeedback"
                  placeholder="Insira seu nome"
                ></b-form-input>
                <b-form-invalid-feedback id="nameInputLiveFeedback">
                  <div class="error" v-if="!$v.formulario.nome.required">
                    Este campo é obrigatório
                  </div>
                  <span class="error" v-if="!$v.formulario.nome.minLength"
                    >Este campo precisa ter pelo menos
                    {{ $v.formulario.nome.$params.minLength.min }}
                    caracteres</span
                  >
                </b-form-invalid-feedback>
                <b-form-valid-feedback></b-form-valid-feedback>
              </b-form-group>
            </b-col>

            <!-- CEP -->
            <b-col order="1" cols="12" md="6">
              <b-form-group>
                <label for="cep-input">CEP</label>
                <b-form-input
                  id="cep-input"
                  v-model="$v.formulario.cep.$model"
                  placeholder="____-___"
                  v-mask="'#####-###'"
                  :state="inputState($v.formulario.cep)"
                  aria-describedby="cepInputLiveFeedback"
                ></b-form-input>
                <b-form-invalid-feedback id="cepInputLiveFeedback">
                  <span class="error" v-if="!$v.formulario.cep.required"
                    >Este campo é obrigatório</span
                  >
                  <span class="error" v-if="!$v.formulario.cep.minLength"
                    >Este campo precisa ter pelo menos
                    {{ $v.formulario.cep.$params.minLength.min }}
                    caracteres</span
                  >
                  <span
                    class="error"
                    v-if="
                      $v.formulario.cep.required &&
                      $v.formulario.cep.minLength &&
                      !$v.formulario.cep.validCEP
                    "
                    >CEP inválido</span
                  >
                </b-form-invalid-feedback>
                <b-form-valid-feedback></b-form-valid-feedback>
              </b-form-group>
            </b-col>

            <!-- Rua/Logradouro -->
            <b-col order="2" cols="12" md="6">
              <b-form-group>
                <label for="endereco-input">Rua/Logradouro</label>
                <b-form-input
                  id="endereco-input"
                  v-model="$v.formulario.endereco.$model"
                  :state="inputState($v.formulario.endereco)"
                  readonly
                  aria-describedby="enderecoInputLiveFeedback"
                ></b-form-input>
                <b-form-invalid-feedback id="enderecoInputLiveFeedback">
                  <div class="error" v-if="!$v.formulario.endereco.required">
                    Este campo é obrigatório
                  </div>
                </b-form-invalid-feedback>
                <b-form-valid-feedback></b-form-valid-feedback>
              </b-form-group>
            </b-col>

            <!-- CPF/CNPJ -->
            <b-col order="3" cols="12" md="6">
              <template v-if="formulario.pessoaTipo != 'Jurídica'">
                <b-form-group>
                  <label for="cpf-input">CPF</label>
                  <b-form-input
                    id="cpf-input"
                    v-model="$v.formulario.cpf.$model"
                    placeholder="___.___.___-__"
                    v-mask="'###.###.###-##'"
                    :state="inputState($v.formulario.cpf)"
                    aria-describedby="cpfInputLiveFeedback"
                    :disabled="formulario.pessoaTipo == null"
                  ></b-form-input>
                  <b-form-invalid-feedback id="cpfInputLiveFeedback">
                    <span class="error" v-if="!$v.formulario.cpf.required"
                      >Este campo é obrigatório</span
                    >
                    <span class="error" v-if="!$v.formulario.cpf.minLength"
                      >Este campo precisa ter pelo menos
                      {{ $v.formulario.cpf.$params.minLength.min }}
                      caracteres</span
                    >
                    <span
                      class="error"
                      v-if="
                        $v.formulario.cpf.required &&
                        $v.formulario.cpf.minLength &&
                        !$v.formulario.cpf.validCPF
                      "
                      >CPF inválido</span
                    >
                  </b-form-invalid-feedback>
                  <b-form-valid-feedback></b-form-valid-feedback>
                </b-form-group>
              </template>

              <template v-if="formulario.pessoaTipo == 'Jurídica'">
                <b-form-group>
                  <label for="cnpj-input">CNPJ</label>
                  <b-form-input
                    id="cnpj-input"
                    v-model="$v.formulario.cnpj.$model"
                    placeholder="__.___.___/____-__"
                    v-mask="'##.###.###/####-##'"
                    :state="inputState($v.formulario.cnpj)"
                    aria-describedby="cnpjInputLiveFeedback"
                  ></b-form-input>
                  <b-form-invalid-feedback id="cnpjInputLiveFeedback">
                    <div class="error" v-if="!$v.formulario.cnpj.required">
                      Este campo é obrigatório
                    </div>
                    <span class="error" v-if="!$v.formulario.cnpj.minLength"
                      >Este campo precisa ter pelo menos
                      {{ $v.formulario.cnpj.$params.minLength.min }}
                      caracteres</span
                    >
                    <span
                      class="error"
                      v-if="
                        $v.formulario.cnpj.required &&
                        $v.formulario.cnpj.minLength &&
                        !$v.formulario.cnpj.validCNPJ
                      "
                      >CNPJ inválido</span
                    >
                  </b-form-invalid-feedback>
                  <b-form-valid-feedback></b-form-valid-feedback>
                </b-form-group>
              </template>
            </b-col>

            <!-- Número -->
            <b-col order="3" cols="12" md="6">
              <b-form-group>
                <label for="numero-input">Número</label>
                <b-form-input
                  id="numero-input"
                  v-model="$v.formulario.numero.$model"
                  placeholder="ex: 32"
                  type="number"
                  min="1"
                  :state="inputState($v.formulario.numero)"
                  aria-describedby="numeroInputLiveFeedback"
                ></b-form-input>
                <b-form-invalid-feedback id="numeroInputLiveFeedback">
                  <div class="error" v-if="!$v.formulario.numero.required">
                    Este campo é obrigatório
                  </div>
                </b-form-invalid-feedback>
                <b-form-valid-feedback></b-form-valid-feedback>
              </b-form-group>
            </b-col>

            <!-- Telefone -->
            <b-col order="4" cols="12" md="6">
              <b-form-group>
                <label for="telefone-input">Telefone</label>
                <b-form-input
                  id="telefone-input"
                  v-model="$v.formulario.telefone.$model"
                  placeholder="(__) _____-____"
                  v-mask="['(##) ####-####', '(##) #####-####']"
                  :state="inputState($v.formulario.telefone)"
                  aria-describedby="telefoneInputLiveFeedback"
                ></b-form-input>
                <b-form-invalid-feedback id="telefoneInputLiveFeedback">
                  <div class="error" v-if="!$v.formulario.telefone.required">
                    Este campo é obrigatório
                  </div>
                  <span class="error" v-if="!$v.formulario.telefone.minLength"
                    >Este campo precisa ter pelo menos
                    {{ $v.formulario.telefone.$params.minLength.min }}
                    caracteres</span
                  >
                </b-form-invalid-feedback>
                <b-form-valid-feedback></b-form-valid-feedback>
              </b-form-group>
            </b-col>

            <!-- Complemento -->
            <b-col order="4" cols="12" md="6">
              <b-form-group label="Complemento" label-for="complemento-input">
                <b-form-input
                  id="complemento-input"
                  v-model="formulario.complemento"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <!-- EMail -->
            <b-col order="5" cols="12" md="6">
              <b-form-group>
                <label for="email-input">E-Mail</label>
                <b-form-input
                  id="email-input"
                  v-model="$v.formulario.email.$model"
                  placeholder="exemplo@email.com"
                  :state="inputState($v.formulario.email)"
                  aria-describedby="emailInputLiveFeedback"
                ></b-form-input>
                <b-form-invalid-feedback id="emailInputLiveFeedback">
                  <div class="error" v-if="!$v.formulario.email.required">
                    Este campo é obrigatório
                  </div>
                  <span class="error" v-if="!$v.formulario.email.email"
                    >E-mail inválido</span
                  >
                </b-form-invalid-feedback>
                <b-form-valid-feedback></b-form-valid-feedback>
              </b-form-group>
            </b-col>

            <!-- Bairro -->
            <b-col order="5" cols="12" md="6">
              <b-form-group>
                <label for="bairro-input">Bairro</label>
                <b-form-input
                  id="bairro-input"
                  v-model="$v.formulario.bairro.$model"
                  :state="inputState($v.formulario.bairro)"
                  readonly
                  aria-describedby="bairroInputLiveFeedback"
                ></b-form-input>
                <b-form-invalid-feedback id="bairroInputLiveFeedback">
                  <div class="error" v-if="!$v.formulario.bairro.required">
                    Este campo é obrigatório
                  </div>
                </b-form-invalid-feedback>
                <b-form-valid-feedback></b-form-valid-feedback>
              </b-form-group>
            </b-col>

            <!-- Cidade -->
            <b-col order="7" cols="12" md="6">
              <b-form-group>
                <label for="cidade-input">Cidade</label>
                <b-form-input
                  id="cidade-input"
                  v-model="$v.formulario.cidade.$model"
                  :state="inputState($v.formulario.cidade)"
                  readonly
                  aria-describedby="cidadeInputLiveFeedback"
                ></b-form-input>
                <b-form-invalid-feedback id="cidadeInputLiveFeedback">
                  <div class="error" v-if="!$v.formulario.cidade.required">
                    Este campo é obrigatório
                  </div>
                </b-form-invalid-feedback>
                <b-form-valid-feedback></b-form-valid-feedback>
              </b-form-group>
            </b-col>

            <!-- Spacing -->
            <b-col order="8" cols="12" md="6"></b-col>

            <!-- Estado -->
            <b-col order="8" cols="12" md="6">
              <b-form-group>
                <label for="selectUF">Estado</label>
                <b-form-input
                  id="selectUF"
                  v-model="$v.formulario.uf.$model"
                  :state="inputState($v.formulario.uf)"
                  readonly
                  aria-describedby="ufInputLiveFeedback"
                  placeholder="Insira o estado"
                ></b-form-input>
                <b-form-invalid-feedback id="ufInputLiveFeedback">
                  <div class="error" v-if="!$v.formulario.uf.required">
                    Este campo é obrigatório
                  </div>
                </b-form-invalid-feedback>
                <b-form-valid-feedback></b-form-valid-feedback>
              </b-form-group>
            </b-col>

            <!-- Arquivos -->
            <b-col order="6" cols="12" md="6">
              <b-form-group :state="fileState">
                <label for="arquivos-input">Arquivos</label>
                <b-form-file
                  id="arquivos-input"
                  v-model="$v.formulario.arquivos.$model"
                  :state="inputState($v.formulario.arquivos)"
                  aria-describedby="arquivosInputLiveFeedback"
                  placeholder="Somente arquivos .doc e .docx"
                  accept=".doc, .docx"
                ></b-form-file>
                <b-form-invalid-feedback id="arquivosInputLiveFeedback">
                  <div v-if="$v.formulario.arquivos.$invalid">
                    <span class="error">Este campo é obrigatório</span>
                    <br />
                    <span class="error"
                      >Somente arquivos .doc e .docx são permitidos</span
                    >
                  </div>
                </b-form-invalid-feedback>
                <b-form-valid-feedback></b-form-valid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
        </form>

        <template #modal-footer>
          <b-button
            size="lg"
            class="mx-3 py-3 btn-modal"
            type="button"
            block
            variant="primary"
            :disabled="
              formStatus !== null &&
              formStatus !== 'ERROR' &&
              formStatus !== 'ERROR-API'
            "
            @click="sendForm"
          >
            Enviar
          </b-button>
          <strong
            class="mx-auto mt-3 text-danger"
            id="status-message-text"
            v-if="formStatus === 'ERROR'"
          >
            Por favor, preencha os campos corretamente.
          </strong>
          <strong
            class="ml-auto mt-3 text-danger"
            id="status-message-text"
            v-if="formStatus === 'ERROR-API'"
          >
            Erro ao Publicar no Diário Oficial
          </strong>
          <span
            class="mr-auto mt-3 text-danger"
            v-if="formStatus === 'ERROR-API'"
          >
            {{ formResponseMsg !== '' ? ': ' + formResponseMsg : '' }}
          </span>
          <strong
            class="mx-auto mt-3 text-secondary"
            id="status-message-text"
            v-if="formStatus === 'PENDING'"
          >
            Enviando... <icon name="spinner" spin></icon>
          </strong>
          <strong
            class="mx-auto mt-3 text-success"
            id="status-message-text"
            v-if="formStatus === 'OK'"
          >
            Formulário enviado com sucesso
          </strong>
        </template>
      </b-modal>
    </b-row>
  </div>
</template>

<script>
  import PortalApi from '@/api/portal'
  import client from '@/main.js'
  import { mask } from 'vue-the-mask'
  import vSelect from 'vue-select'
  import { validationMixin } from 'vuelidate'
  import { cpf, cnpj } from 'cpf-cnpj-validator'
  import {
    required,
    minLength,
    email,
    requiredIf
  } from 'vuelidate/lib/validators'
  import axios from 'axios'

  const validCEP = (value, vm) => {
    return vm.validCEP === true
  }
  const validCPF = (value, vm) => {
    if (
      (value.length === 14 && cpf.isValid(value)) ||
      vm.pessoaTipo === 'Jurídica'
    ) {
      return true
    }
    return false
  }
  const validCNPJ = (value, vm) => {
    if (
      (value.length === 18 && cnpj.isValid(value)) ||
      vm.pessoaTipo !== 'Jurídica'
    ) {
      return true
    }
    return false
  }

  export default {
    data() {
      return {
        adminUrl: '',
        client: null,
        tituloPagina: '',
        tituloRowBG: '',
        textoSobre: '',
        tituloContato: '',
        formulario: {
          nome: '',
          cep: '',
          endereco: '',
          cpf: '',
          cnpj: '',
          numero: '',
          telefone: '',
          complemento: '',
          email: '',
          bairro: '',
          cidade: '',
          uf: '',
          arquivos: null,
          pessoaTipo: 'Física',
          validCEP: false
        },
        tipoPessoa: ['Física', 'Jurídica'],
        fileState: true,
        formStatus: null,
        formResponseMsg: ''
      }
    },
    directives: { mask },
    mixins: [validationMixin],
    components: {
      vSelect
    },
    validations: {
      formulario: {
        nome: {
          required,
          minLength: minLength(3)
        },
        cep: {
          required,
          minLength: minLength(9),
          validCEP
        },
        endereco: {
          required
        },
        cpf: {
          required: requiredIf(function () {
            return this.formulario.pessoaTipo !== 'Jurídica'
          }),
          minLength: requiredIf(function () {
            if (this.formulario.pessoaTipo === 'Jurídica') {
              return false
            } else {
              return minLength(14)
            }
          }),
          validCPF
        },
        cnpj: {
          required: requiredIf(function () {
            return this.formulario.pessoaTipo === 'Jurídica'
          }),
          minLength: requiredIf(function () {
            if (this.formulario.pessoaTipo !== 'Jurídica') {
              return false
            } else {
              return minLength(18)
            }
          }),
          validCNPJ
        },
        numero: {
          required
        },
        telefone: {
          required,
          minLength: minLength(13)
        },
        email: {
          required,
          email
        },
        bairro: {
          required
        },
        cidade: {
          required
        },
        uf: {
          required
        },
        arquivos: {
          required: requiredIf(function () {
            return !this.formulario.arquivos
          })
        },
        pessoaTipo: {
          required
        }
      }
    },
    created() {
      let me = this
      me.adminUrl = client.adminUrl
      me.client = client.CLIENT
      me.tituloPagina = client.clientData.about.title
      me.textoSobre = client.clientData.about.text
      me.tituloContato = client.clientData.about.contactText
      me.tituloRowBG = {
        backgroundImage:
          'url(' +
          require('@/assets/imagens/' + me.client + '/tituloPagFdo.png') +
          ')'
      }
    },
    methods: {
      scrollIntoMessage(formStatus) {
        if (formStatus) {
          this.formStatus = formStatus
        }

        if (document.getElementById('status-message-text')) {
          document
            .getElementById('status-message-text')
            .scrollIntoView({ behavior: 'smooth' })
        }
      },
      resetForm() {
        const form = {
          nome: '',
          cep: '',
          endereco: '',
          cpf: '',
          cnpj: '',
          numero: '',
          telefone: '',
          complemento: '',
          email: '',
          bairro: '',
          cidade: '',
          uf: '',
          arquivos: null,
          pessoaTipo: 'Física',
          validCEP: false
        }
        this.formulario = form
      },
      sendForm() {
        const me = this
        const formulario = me.$v.formulario
        me.formResponseMsg = ''
        formulario.$touch()

        if (formulario.$invalid) {
          me.scrollIntoMessage('ERROR')
        } else {
          me.scrollIntoMessage('PENDING')

          const promisse = PortalApi.fetchPublishPortal(this.formulario)
          promisse.then(
            () => {
              me.scrollIntoMessage('OK')
            },
            (error) => {
              me.scrollIntoMessage('ERROR-API')

              if (error.response && error.response.data) {
                const { message } = error.response.data
                me.formResponseMsg = message
              }
            }
          )
        }
      },
      getCep() {
        const me = this
        const baseCep = 'https://viacep.com.br/ws/'
        let cep = this.formulario.cep.replace('-', '')
        const url = `${baseCep}${cep}/json/`
        axios.get(url).then((resp) => {
          const data = resp.data
          if (!data.erro) {
            me.formulario.validCEP = true
            me.formulario.bairro = data.bairro
            me.formulario.cidade = data.localidade
            me.formulario.endereco = data.logradouro
            me.formulario.uf = data.uf
          } else {
            me.formulario.validCEP = false
            me.cleanCepData()
          }
        })
      },
      cleanCepData() {
        const me = this
        me.formulario.bairro = ''
        me.formulario.cidade = ''
        me.formulario.endereco = ''
        me.formulario.uf = ''
      },
      inputState(field) {
        if (!field.$dirty) {
          // field.$touch() // validar todos os campos ao abrir form
          return null
        }
        return !field.$error
      },
      togglePersonType() {
        const me = this
        me.formulario.cpf = ''
        me.formulario.cnpj = ''
      }
    },
    computed: {
      testFiles() {
        return this.formulario.arquivos
      },
      testCep() {
        return this.formulario.cep
      }
    },
    watch: {
      testFiles(val) {
        const me = this
        if (!val || !val.name) return null
        const name = val.name
        if (name.includes('.doc') || name.includes('.docx')) {
          me.fileState = true
          return val
        } else {
          me.fileState = false
          me.formulario.arquivos = null
          return null
        }
      },
      testCep(novoCep) {
        if (novoCep.length === 9) this.getCep()
        else this.cleanCepData()
      }
    }
  }
</script>

<style lang="scss">
  @import '../assets/scss/estilos.scss';
  .textoCinza {
    color: #b3b3b3;
  }
  #publicarNoDiario {
    .card-header {
      padding: 0.75rem;
    }
  }
  .card-body {
    display: grid;
    align-items: center;
    border-radius: 4px;
  }
  .lista-formatacao {
    font-size: 15px;
    font-style: italic;
  }
  .modal-title {
    padding: 0 1rem;
  }
  .btn.btn-modal {
    border-radius: 4px;
  }
  /* Media Queries */
  /* iPad */
  @media (min-width: 768px) and (max-width: 991.98px) {
    #selectPessoa {
      .selected-tag {
        position: absolute;
      }
    }
  }
  /* xs */
  @media (max-width: 355px) {
    #selectPessoa {
      .selected-tag {
        position: absolute;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/PublicarDiarioOficial.vue